import { Box } from '@components/gassan-ui'
import styled from 'styled-components'

export const RolexContainer = styled(Box)`
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  margin: 0 auto;
  max-width: 1680px;
`
